export function init($name) {
    if (!$($name).length) {
        return;
    }

    const counter = new CounterAction($name);

    counter.init();

    window.counter = counter;
}

function prepare($name) {
    const counter = $($name);

    if ($(window).width() > 757) {
        return;
    }

    counter.on('init', (event, slick) => {
        let actualSlide = slick.$slides[0];
        $(actualSlide).addClass('js-counter-active');
    });

    counter.on('afterChange', (event, slick, currentSlide) => {
        let actualSlide = slick.$slides[currentSlide];
        $(actualSlide).addClass('js-counter-active');

        slick.$slides.each((i, slide) => {
            if(i !== currentSlide) {
                $(slide).removeClass('js-counter-active');
            }
        });
    });

    counter.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        let actualSlide = slick.$slides[currentSlide];
        let newSlide = slick.$slides[nextSlide];
        $(actualSlide).removeClass('js-counter-active');
        $(newSlide).removeClass('js-counter-active');
    });

    counter.slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        variableWidth: false,
        centerMode: true,
        swipe: true,
        swipeToSlide: true,
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" name="Previouse" title="Previouse" value="Previouse" class="slick-prev"><i class="icon icon-arrow_left"></i></button>',
        nextArrow: '<button type="button" name="Next" title="Next" value="Next" class="slick-next"><i class="icon icon-arrow_right"></i></button>',
    });
}

//
//
//
//

function CounterAction($name) {
    this.counters = $('.js-count-number:not(.initialized)');
    this.init = function () {

        if (this.counters.length) {

            this.counters.each(function (i, counter) {

                let contents = $(counter).data('target');
                const contentsContainer = $('<div class="counter-contents-container"></div>')
                const separator = $(counter).data('separator');
                if (separator && contents >= 1000) {
                    contents = new Intl.NumberFormat('en-US').format(contents).split('');
                } else {
                    contents = String(contents).split('')
                }

                $(contents).each(function (i, content) {
                    const contentList = $('<ul class="counter-content-list"></ul>');

                    if (content === ',') {
                        contentList.append('<li class="counter-content-item">,</li>');
                        contentList.addClass('counter-content-item--unactive');
                    } else {
                        const number = Number(content);
                        if (number > 5) {
                            for (let i = number; i >= 0; i--) {
                                contentList.append(`<li class="counter-content-item">${i}</li>`)
                            }
                        } else {
                            for (let i = number; i <= 9; i++) {
                                contentList.append(`<li class="counter-content-item">${i}</li>`)
                            }
                        }
                    }

                    contentsContainer.append(contentList);
                });

                $(counter).html(contentsContainer);
            });
        }

        prepare('.steps-hld');
    };

    this.fireAnimations = function () {
        if (this.counters.length) {
            this.counters.each(function (i, counter) {
                $(counter).addClass('js-counter-active');
            });
        }
    };

    this.stopAnimations = function () {
        if (this.counters.length) {
            this.counters.each(function (i, counter) {
                $(counter).removeClass('js-counter-active');
            });
        }
    }
}

export function ieFix($name) {
    if (!$($name).length) {
        return;
    }

    $($name).each(function(){
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") ).addClass('initialized');
    });
}
